import React from 'react';
import { FormattedMarkdown } from '@qover/react-intl';
import { Popover } from '@qover/molecules';
import { PopoverLabel } from './summaryInsurance.styles';
import { Trans } from '@lingui/react';

const insuranceOptions = (popoverContent) => ({
  overrides: {
    a: p => (
      <>
        &nbsp;
        <Popover
          button={
            <PopoverLabel className="font-bold color-secondary">
              {p.children}
            </PopoverLabel>
          }
          id="summary.renewable"
        >
          {popoverContent}
        </Popover>
      </>
    ),
  },
})

export default {
  insuranceTitle: <Trans id="general.summaryInsurance.title" />,
  insurance: (values, popoverContent) => (
    <FormattedMarkdown
      id="general.summaryInsurance.insurance"
      values={values}
      options={insuranceOptions(popoverContent)}
    />
  ),
  insuranceWithDuration: (values, popoverContent) => (
    <FormattedMarkdown
      id="general.summaryInsurance.insuranceWithDuration"
      values={values}
      options={insuranceOptions(popoverContent)}
    />
  ),
  renewableContent: (
    <FormattedMarkdown id="general.summaryInsurance.renewableContent" />
  ),
};
